import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Confirm_Modal from "../../Common/Common_Component/Common_Modal/Confirm_Modal/Confirm_Modal";

function BottomNav() {
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();


  const handleLogout = async () => {
    setModalShow(true);
  };

  return (
    <>
      <div className="bottom-nav">
        <button className="btn-register my-5" onClick={handleLogout}>
          Log out
        </button>
      </div>

      <Confirm_Modal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default BottomNav;